
import axios from 'axios';
import { useQuery } from 'react-query';

const fetchjobs = () => {
    return axios.get('https://remotive.com/api/remote-jobs?category=software-dev')
}

export const useRemoteOk = () => {
    return useQuery('jobs', fetchjobs, {
        select: (data) => {
            const worldwideJobs = data.data.jobs.filter((job) => job.candidate_required_location === 	"Worldwide")
            return worldwideJobs
        },
        refetchOnWindowFocus: false,
        cacheTime:1200000,
        staleTime:600000
    })
};
